module.exports = __webpack_public_path__ + "img/map-santos.9126acf4.svg";